import React from 'react';

const BUBBLE_PATH = 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z';

/** Speech bubble: the comments panel, its launcher and the empty state. */
export const ChatGlyph = ({ size = 16, strokeWidth = 1.8 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
        <path d={BUBBLE_PATH} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/** Downward chevron: collapse the panel, or jump down to the latest message. */
export const ChevronGlyph = ({ size = 16, strokeWidth = 2 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
        <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/** Paper plane for the send button. */
export const SendGlyph = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
        <path
            d="M4.4 11.5 19.6 4.4a.6.6 0 0 1 .8.8l-7.1 15.2a.6.6 0 0 1-1.1-.1l-1.9-6-6-1.9a.6.6 0 0 1-.1-1.1Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
        />
    </svg>
);
